export const categoryEnum = {
    "HSE": 0
};

export const subCategoryEnum = {
    "HSE": {
        "SiteVisits": 0
    }
};